import { render, staticRenderFns } from "./SalesClientsStackedChart.vue?vue&type=template&id=8814a0c8&scoped=true"
import script from "./SalesClientsStackedChart.vue?vue&type=script&lang=js"
export * from "./SalesClientsStackedChart.vue?vue&type=script&lang=js"
import style0 from "./SalesClientsStackedChart.vue?vue&type=style&index=0&id=8814a0c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8814a0c8",
  null
  
)

export default component.exports